// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-7c82f5aa]{display:flex;flex-shrink:0;align-items:center;object-fit:contain;cursor:pointer}.logo__img[data-v-7c82f5aa]{width:auto;height:26px}@media(min-width:800px){.logo__img[data-v-7c82f5aa]{height:40px}}.logo__img.mini[data-v-7c82f5aa]{height:48px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
